import React, {useState, useEffect} from 'react';
import GenericModal from '../generic_modal';
import {BUTTON_COLOR, PROJECT_STATUS} from '../../../constants';
import NestedDropdown from '../../../forecast-app/shared/components/dropdowns/nested_dropdown';
import ForecastQueryRenderer from '../../../ForecastQueryRenderer';
import TaskList, {taskListQuery} from './task_list';
import {Row, Container, Text, NestedDropdownStyle, LoaderContainer} from './project_automate_modal.styled';
import Util from '../../../forecast-app/shared/util/util';
import UpdateTasksBulkMutation from '../../../mutations/update_tasks_bulk_mutation.modern';
import AiLoader from '../../../components/loaders/ai_loader';
import * as tracking from '../../../tracking';

export const VARIANT = {
	ASSIGNEES: 'assignees',
	ROLES: 'roles',
	ESTIMATES: 'estimates',
	LABELS: 'labels',
};

export const ProjectAutomateModal = ({closeModal, variant, tasks, intl, allProjects, currentProject, roles, persons, labels}) => {
	const [selectedSimilarProject, setSelectedSimilarProject] = useState(null);
	const [errors, setErrors] = useState(false);
	const [taskListState, setTaskListState] = useState({});

	const TEXTS = {
		assignees: {
			header: intl.formatMessage({id: 'automate.automate_team_members'}),
			info: intl.formatMessage({id: 'automate.info_team_members'}),
		},
		roles: {
			header: intl.formatMessage({id: 'automate.automate_roles'}),
			info: intl.formatMessage({id: 'automate.info_roles'}),
		},
		estimates: {
			header: intl.formatMessage({id: 'automate.automate_estimates'}),
			info: intl.formatMessage({id: 'automate.info_estimates'}),
		},
		labels: {
			header: intl.formatMessage({id: 'automate.automate_labels'}),
			info: intl.formatMessage({id: 'automate.info_labels'}),
		},
	};

	const getProjectsDropdownOptions = (intl, projects, currentProject) => {
		let projectOptions = [];
		const {formatMessage} = intl;
		const running_projects = [],
			planning_projects = [],
			halted_projects = [],
			done_projects = [];

		const currentProjectId = currentProject ? currentProject.id : '';
		projects
			.filter(project => project.node.id !== currentProjectId)
			.forEach(project => {
				const el = {
					id: project.node.id,
					projectColor: project.node.projectColor,
					name: project.node.name,
					companyProjectId: project.node.companyProjectId,
					label: project.node.name,
				};
				if (project.node.status === PROJECT_STATUS.PLANNING) {
					planning_projects.push(el);
				} else if (project.node.status === PROJECT_STATUS.RUNNING) {
					running_projects.push(el);
				} else if (project.node.status === PROJECT_STATUS.HALTED) {
					halted_projects.push(el);
				} else if (project.node.status === PROJECT_STATUS.DONE) {
					done_projects.push(el);
				}
			});

		const sortProjects = (a, b) => {
			if (a.sortValue < b.sortValue) return -1;
			if (a.sortValue > b.sortValue) return 1;
			if (a.sortValue === b.sortValue) {
				if (a.isInProjectGroup && !b.isInProjectGroup) {
					return 1;
				}
			}
			return 0;
		};
		running_projects.sort(sortProjects);
		planning_projects.sort(sortProjects);
		halted_projects.sort(sortProjects);
		if (planning_projects.length > 0) {
			projectOptions.push({value: 'planning_projects', label: formatMessage({id: 'project_status.planning'}), nestedOptions: planning_projects, collapseByDefault: true});
		}
		if (running_projects.length > 0) {
			projectOptions.push({value: 'running_projects', label: formatMessage({id: 'project_status.running'}), nestedOptions: running_projects, collapseByDefault: true});
		}
		if (done_projects.length > 0) {
			projectOptions.push({value: 'done_projects', label: formatMessage({id: 'project_status.done'}), nestedOptions: done_projects});
		}
		if (halted_projects.length > 0) {
			projectOptions.push({value: 'halted_projects', label: formatMessage({id: 'project_status.halted'}), nestedOptions: halted_projects, collapseByDefault: true});
		}

		return projectOptions;
	};

	//this is trigger when the Task list return the AI information, so we use this function maninly for tracking the AI
	/* 	const handleSetTaskListState = val => {
		const handle = size => {
			tracking.trackAIEvent('Inserted Shown', variant, size);

			console.log('TRACKING', val);
		};
		let sizeVal = 0;
		let sizeTaskListState = 0;
		switch (variant) {
			case VARIANT.ASSIGNEES:
				sizeVal = _.size(val.assigneesAI);
				sizeTaskListState = _.size(taskListState.assigneesAI);
				console.log('TRACKING', sizeVal, sizeTaskListState);
				if (sizeVal !== sizeTaskListState) {
					console.log('TRACKING', 'in');

					handle(sizeVal);
				}
				break;
			case VARIANT.ROLES:
				sizeVal = _.size(val.rolesAi);
				if (sizeVal !== _.size(taskListState.rolesAi)) {
					handle(sizeVal);
				}
				break;
			case VARIANT.LABELS:
				sizeVal = _.size(val.labelsAI);
				if (sizeVal !== _.size(taskListState.labelsAI)) {
					handle(sizeVal);
				}
				break;
			default:
				break;
		}
	}; */

	useEffect(() => {
		tracking.trackAIEvent('triggered', variant);
	}, []);

	/* useEffect(() => {
		const size = _.size(taskListState.assigneesAI);
		console.log('TRACKING size', size);
	}, [taskListState.assigneesAI]); */

	const handleSimilarProjectSelect = selectedSimilarProject => {
		setSelectedSimilarProject(selectedSimilarProject);
	};

	const getContent = () => {
		return (
			<Container>
				{variant !== VARIANT.LABELS && (
					<Row>
						<Text>{intl.formatMessage({id: 'auto_scheduling.unestimated_tasks_projects_dropdown_info'})}</Text>
						<NestedDropdownStyle>
							<NestedDropdown
								placeholder={intl.formatMessage({id: 'auto_scheduling.select_similar_input_default'})}
								options={getProjectsDropdownOptions(intl, allProjects.edges, currentProject)}
								onChange={handleSimilarProjectSelect}
								projectIdLabel={selectedSimilarProject ? {companyProjectId: selectedSimilarProject.companyProjectId, projectColor: selectedSimilarProject.projectColor} : null}
								value={selectedSimilarProject ? selectedSimilarProject.name : null}
								showBorder={true}
								small={true}
								useBlackColor={true}
								showPlaceHolderWhenExpanded
								showArrowWhenCollapsed={true}
							/>
						</NestedDropdownStyle>
					</Row>
				)}
				<Row>
					<Text>{TEXTS[variant].info}</Text>
				</Row>
				<Row last={true}>
					<ForecastQueryRenderer
						query={taskListQuery}
						showLoader={true}
						key="automate-modal-query"
						componentName={'task_list'}
						customLoader={() => (
							<LoaderContainer>
								<AiLoader />
							</LoaderContainer>
						)}
						variables={{
							fetchHighLow: variant === VARIANT.ESTIMATES,
							fetchRoles: variant === VARIANT.ROLES,
							fetchAssignee: variant === VARIANT.ASSIGNEES,
							fetchLabels: variant === VARIANT.LABELS,
							taskIds: tasks.map(task => task.id),
							similarProjectId: selectedSimilarProject ? selectedSimilarProject.id : null,
						}}
						render={(relayProps, retry) => (
							<TaskList
								passState={setTaskListState}
								onError={setErrors}
								intl={intl}
								{...relayProps}
								retry={retry}
								tasks={tasks}
								labels={labels.edges.map(edge => edge.node)}
								roles={roles.edges.map(edge => edge.node)}
								lowVisible={variant === VARIANT.ESTIMATES}
								highVisible={variant === VARIANT.ESTIMATES}
								estimateVisible={variant === VARIANT.ESTIMATES}
								roleVisible={variant === VARIANT.ROLES}
								assigneesVisible={variant === VARIANT.ASSIGNEES}
								labelsVisible={variant === VARIANT.LABELS}
								persons={persons}
							/>
						)}
					/>
				</Row>
			</Container>
		);
	};
	const saveUpdate = () => {
		let tasksToUpdate = tasks.map(task => {
			return {
				taskId: task.id,
				estimateLow: variant === VARIANT.ESTIMATES ? (taskListState.removeLowHigh ? taskListState.estimates[task.id] * 60 : taskListState.lowEstimates[task.id] * 60) : undefined,
				estimateHigh: variant === VARIANT.ESTIMATES ? (taskListState.removeLowHigh ? taskListState.estimates[task.id] * 60 : taskListState.highEstimates[task.id] * 60) : undefined,
				estimateForecast: variant === VARIANT.ESTIMATES && taskListState.removeLowHigh ? taskListState.estimates[task.id] * 60 : undefined,
				personIds: variant === VARIANT.ASSIGNEES ? taskListState.assignees[task.id] : undefined,
				roleId: variant === VARIANT.ROLES ? taskListState.roles[task.id] : undefined,
				labelIds: variant === VARIANT.LABELS ? taskListState.labels[task.id] : undefined,
			};
		});

		Util.CommitSchedulingModalUpdatePromise(UpdateTasksBulkMutation, {tasks: tasksToUpdate});
		tracking.trackAIEvent('Applied', variant);
	};

	return (
		<GenericModal
			cy={'project-automate-modal'}
			headerText={TEXTS[variant].header}
			content={getContent()}
			closeModal={closeModal}
			buttons={[
				{
					text: intl.formatMessage({id: 'common.cancel'}),
					color: BUTTON_COLOR.WHITE,
				},
				{
					id: 'auto-schedule-continue-button',
					cy: 'auto-schedule-continue-button',
					text: intl.formatMessage({id: 'common.update'}),
					disabled: errors,
					callback: saveUpdate,
					autoScheduleStyle: true,
				},
			]}
		/>
	);
};
